import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const styles = {
  overlay: {
    position: 'fixed',
    height: '100vh',
    overflowY: 'hidden',
    width: '100%',
    zIndex: 999,
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    minWidth: '19.25rem',
    maxWidth: '36.25rem',
    padding: 0,
    position: 'absolute',
    overflowX: 'hidden',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: '0.5rem',
    backgroundColor: '#fff',
    boxShadow: '0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.25)'
  }
}

export const ModalHeader = styled.h2`
  padding: 2.5rem 0;
  color: ${p => p.theme.colors.black};
  font-size: 1.5rem;
  line-height: 1.75rem;
  text-align: center;

  ${media.md`
    padding: 2.5rem 6.25rem;
  `}
`

export const ModalBody = styled.p`
  min-width: 18.75rem;
  margin: 0 auto 2.5rem;
  padding: 0 2rem;
  color: ${p => p.theme.colors.mediumGrey};
  font-size: 0.875rem;
  line-height: 1.125rem;
  text-align: center;
  font-weight: 600;

  ${media.xs`
    min-width: auto;
    padding: 0 1.5rem;
  `}

  ${media.md`
    min-width: 580px;
    padding: 0 3rem;
  `}
`

export const ModalFooter = styled.div`
  padding: 0.875rem 0.5rem;
  display: flex;
  justify-content: flex-end;
  border-top: 0.0625rem solid #eee;
`
